import React, { Fragment, useEffect,useState,useReducer } from "react";
import {connect} from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Row,Col,Card,Table,Button,Modal,Dropdown} from "react-bootstrap";
import ToastAlert from "../components/Magpie/ToastAlert";
import {useNavigate} from 'react-router-dom';
import PagePagination from "../components/Magpie/PagePagination";
import useAuthIngest from "../../hooks/useAuthIngest"
import {getRoleAsync} from "../../store/actions/role.action";
import {Formik} from 'formik';
import * as Yup from "yup";
import Input from "../components/Magpie/Input";
import AutoCompleteField from "../components/Magpie/AutoCompleteField";
import '../../css/autocomplete-css.css'
import SweetAlertButton from "../components/Magpie/SweetAlertButton";
import useAuthGetData from "../../hooks/useAuthGetData";
import swal from "sweetalert";
import TextArea from "../components/Magpie/TextArea";


Yup.addMethod(Yup.string, "checkDecimal", function (errorMessage) {
    return this.test(`check-decimal`, errorMessage, function (value) {
        const { path, createError } = this;
        let regexGlobal = /^(\d+(?:[\.]\d{1,2})?)$/;
        let testValue = typeof value === 'undefined' ? 0 : value
        return (
            (regexGlobal.test(testValue)) || createError({ path, message: errorMessage })
        );
    });
});

const userSchema = Yup.object().shape({
    customers: Yup.string()
        .required("Please provide a customer name")
        .max(250, "Provided name is too long"),
    credit:Yup.string()
        .checkDecimal("Please provide a valid amount"),
    debit:Yup.string()
        .checkDecimal("Please provide a valid amount")

});

const LedgerManage = ({roleFunc,roles,login,mount,orgSession}) => {

    let currentDate = new Date()
    let dayFormat = new Date(currentDate)
    let yday = dayFormat.setDate(dayFormat.getDate() - 1)
    let yDate = new Date(yday);

    const [message,setMessage] = useState("");
    const [status, setStatus] = useState(false);
    const [isSuccess,setIsSuccess] = useState(false);
    const [fired,setFired] = useState(false);
    const [dayValue, setDayValue] = useState(0);
    const [peginateData, setPeginateData] = useState({});
    const navigate = useNavigate();
    const [btnLoad, setBtnLoad] = useState(false);
    const [btnEdit, setBtnEdit] = useState(false);
    const [btnClose, setBtnClose] = useState(false);
    const [editable, setEditable] = useState(false);
    const [scrHeight, setScrHeight] = useState('0px');
    const [customerName, setCustomerName] = useState('');
    const [filterDate, setFilterDate] = useState(yDate);
    const [ledgerData, setLedgerData] = useState({status:false});
    const [customer, setCustomer] = useState("");
    const [debit, setDebit] = useState("");
    const [credit, setCredit] = useState("");
    const [ledgerId, setLedgerId] = useState(0);
    const [comment, setComment] = useState("");
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [isFilterFire, setIsFilterFire] = useState(false);


    const  HandleDimension = () => {
        const { innerWidth: width, innerHeight: height } = window;
        let avilHeight = Math.ceil((height/2))+'px'
        setScrHeight(height)
    }

    useEffect(() => {
        if(mount.status){
            if(login.isLogin){
                roleFunc()
                HandleDimension()
            }
            else{
                navigate("/login");
            }
        }
    }, [login,mount]);

    useEffect(() => {
        if(ledgerData.status){
            peginate(1,1000)
        }
    }, [ledgerData]);

    const HandleDelete  = async (values) =>{
        setFired(false)
        const respond = await useAuthIngest('/ledger-delete',{ledger_id:values});
        setFired(true)
        setMessage(respond.message)
        setStatus(respond.status)
        if(respond.status){
            GetLedger()
        }
    }

    const peginate = (page, perPage) => {
        let data = [];
        if(ledgerData.status && ledgerData.data.length > 0){
            let st = (page - 1) * perPage
            let chunk = page * perPage
            data =  ledgerData.data.slice(st, chunk);
        }
        setPeginateData(data)
    }

    const InsertLedger = async (values) => {
        const respond = await useAuthIngest('/add-ledger',values);
        setFired(true)
        setBtnLoad(false)
        setMessage(respond.message)
        setStatus(respond.status)
        if(respond.status){
            setCustomerName("")
            GetLedger()
        }

    }

    const UpdateLedger = async (values) => {
        setFired(false)
        const respond = await useAuthIngest('/update-ledger',values);
        setFired(true)
        setBtnLoad(false)
        if(respond.status){
            setCustomerName("")
            GetLedger()
            CancelEdit()
        }
        setMessage(respond.message)
        setStatus(respond.status)

    }

    const SubmitFunction = async (values) => {
        setFired(false)
        setBtnLoad(true)
        if(values.credit !== "" || values.debit !== "" ){
            if(typeof orgSession.data.id !== 'undefined' ){
                values.company_id = orgSession.data.id;
                values.customers = customerName === '' ? values.customers : customerName;
                values.day = filterDate.toISOString().split('T')[0];
                if(ledgerId > 0){
                    values.ledgerId = ledgerId;
                    UpdateLedger(values)
                }
                else
                    InsertLedger(values)
            }else{
                setFired(true)
                setMessage("Please select company")
                setStatus(false)
                setBtnLoad(false)
            }
        }else{
            setFired(true)
            setMessage("Please provide transaction Amount")
            setStatus(false)
            setBtnLoad(false)
        }
    }

    const handleSuggestion = (value) => {
        setCustomerName(value)
    }

    const LedgerSummery = async () => {
        let respond =  await useAuthGetData('ledger-day-summery',{company_id:orgSession.data.id,day:filterDate.toISOString().split('T')[0]})
        if(respond[0].status){
            setDayValue(respond[0].data);
        }
        setEditable(!respond[1].status)
    }

    const DayClosing = async () => {
        setFired(false)
        setBtnClose(true)
        const respond = await useAuthIngest('/close-ledger',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setFired(true)
        setMessage(respond.message)
        setStatus(respond.status)
        setBtnClose(false)
        if(respond.status){
            FilterData()
        }
    }

    const yesterday = () => {
        return yday
    }

    const FilterData = async () => {
        setFired(false)
        setBtnLoad(true)
        const respond = await useAuthGetData('/ledger-data-history-summery',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setBtnLoad(false)
        setLedgerData(respond)
        setIsFilterFire(false)
        if(!respond.status){
            setFired(true)
            setIsFilterFire(true)
            setLedgerData({status:false})
            setMessage(respond.message)
            setStatus(respond.status)
        }else{
            LedgerSummery()
        }
    }

    const GetLedger = async () => {
        const respond = await useAuthGetData('/ledger-data-history-summery',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setLedgerData(respond)
        if(!respond.status){
            setLedgerData({status:false})
        }else{
            LedgerSummery()
        }
    }

    const ResetFilters = () => {
        setLedgerData({status:false})
        setEditable(false)
        setIsFilterFire(false)
        CancelEdit()
    }

    const AddLedger = () => {
        setEditable(true)
    }

    const EditData = async () => {
        setFired(false)
        setBtnEdit(true)
        const respond = await useAuthGetData('/ledger-rollback',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setBtnEdit(false)
        setEditable(respond.status)
        if(!respond.status){
            setFired(true)
            setMessage(respond.message)
            setStatus(respond.status)
        }
    }

    const ledgerDataEdit = (data) => {
        setCustomer(data.customer_name)
        setCustomerName(data.customer_name)
        setComment(data.comment)
        setLedgerId(data.id)
        setDebit(data.transaction_type === 'D' ? (Math.round(Math.abs(data.tran_amount) * 100) / 100).toFixed(2) : 0)
        setCredit(data.transaction_type === 'C' ? (Math.round(Math.abs(data.tran_amount) * 100) / 100).toFixed(2) : 0)
    }

    const CancelEdit = () => {
        setCustomer('')
        setCustomerName('')
        setLedgerId(0)
        setDebit('')
        setCredit('')
        setComment('')
    }

    return (
        <Fragment>
            <Row>
                {
                    fired ? <ToastAlert message={message} status={status} /> : ""
                }
                <Col lg={12} style={{minHeight:scrHeight}}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Ledger Manage</Card.Title>
                            {
                                ledgerData.status ?
                                    <Card.Title>{dayValue.toLocaleString()}</Card.Title>
                                    : ""

                            }

                        </Card.Header>
                        <Card.Body>
                            <div className="mb-2"></div>
                            {
                                !ledgerData.status ?
                                    <Fragment>
                                        {
                                            !isFilterFire ?
                                                <Row>
                                                    <Col sm={12} md={4} lg={4}></Col>
                                                    <Col sm={12} md={4} lg={4}>
                                                        <DatePicker  dateFormat="yyyy-MM-dd" maxDate={yesterday()} className="form-control" selected={filterDate} onChange={(date) => setFilterDate(date)} />
                                                    </Col>
                                                    <Col sm={12} md={4} lg={4}>
                                                        {
                                                            !btnLoad ?
                                                                <Button
                                                                    variant=""
                                                                    type="button"
                                                                    className="btn btn-primary w-100"
                                                                    onClick={FilterData}
                                                                >
                                                                    Search
                                                                </Button>
                                                                :
                                                                <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                                        }
                                                    </Col>
                                                </Row>
                                                    :
                                                <Row>
                                                    <Col sm={12} md={4} lg={4}></Col>
                                                    <Col sm={12} md={4} lg={4}>
                                                        {
                                                            !editable ?
                                                            <Button
                                                                variant=""
                                                                type="button"
                                                                className="btn btn-primary w-100"
                                                                onClick={AddLedger}
                                                            >
                                                                Add Ledger
                                                            </Button>
                                                                : ""
                                                        }
                                                    </Col>
                                                    <Col sm={12} md={4} lg={4}>
                                                        {
                                                            <Button
                                                                variant=""
                                                                type="button"
                                                                className="btn btn-warning w-100"
                                                                onClick={ResetFilters}
                                                            >
                                                                Back
                                                            </Button>
                                                        }
                                                    </Col>
                                                </Row>

                                        }
                                    </Fragment>
                                    :
                                    (
                                        !editable ?
                                            <Row>
                                                <Col sm={12} md={4} lg={4}></Col>
                                                <Col sm={12} md={4} lg={4}>
                                                    {
                                                        !btnEdit ?
                                                            <Button
                                                                variant=""
                                                                type="button"
                                                                className="btn btn-primary w-100"
                                                                onClick={EditData}
                                                            >
                                                                Edit
                                                            </Button>
                                                            :
                                                            <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                                    }
                                                </Col>
                                                <Col sm={12} md={4} lg={4}>
                                                    {
                                                        <Button
                                                            variant=""
                                                            type="button"
                                                            className="btn btn-warning w-100"
                                                            onClick={ResetFilters}
                                                        >
                                                            Back
                                                        </Button>
                                                    }
                                                </Col>
                                            </Row>
                                            :
                                            <Row>
                                                <Col sm={12} md={4} lg={4}></Col>
                                                <Col sm={12} md={4} lg={4}></Col>
                                                <Col sm={12} md={4} lg={4}>
                                                    {
                                                        <Button
                                                            variant=""
                                                            type="button"
                                                            className="btn btn-warning w-100"
                                                            onClick={ResetFilters}
                                                        >
                                                            Back
                                                        </Button>
                                                    }
                                                </Col>
                                            </Row>
                                    )
                            }

                            <div className="mb-3"></div>
                            <Row>
                                {
                                    editable ?
                                        <Col sm={12} md={3} lg={3}>

                                            <Formik
                                                initialValues={{
                                                    customers: customer,
                                                    credit: credit,
                                                    debit: debit,
                                                    comment: comment,
                                                }}
                                                enableReinitialize={true}
                                                validationSchema={userSchema}
                                                onSubmit={(values, { setSubmitting,resetForm }) => {
                                                    setTimeout(() => {
                                                        SubmitFunction(values)
                                                        setSubmitting(false);
                                                        resetForm({values:''})
                                                    }, 400);
                                                }}

                                            >
                                                {({ values,errors,handleChange,handleBlur,handleSubmit,isSubmitting }) => (
                                                    <form className="dz-form dzForm style-1 contact-bx" noValidate onSubmit={handleSubmit}>
                                                        <div className="row ">
                                                            <div className="col-md-12">
                                                                <label>Company Name </label>
                                                                <h4>{orgSession.data.name}</h4>
                                                            </div>
                                                            {
                                                                customer === "" ?
                                                                    <div className="col-md-12">
                                                                        <AutoCompleteField
                                                                            name="customers"
                                                                            placeholder="Customers"
                                                                            id="customers"
                                                                            errors={errors.customers}
                                                                            value={values.customers}
                                                                            handleChange={handleChange}
                                                                            isRequired={false}
                                                                            formRequired={false}
                                                                            handleSuggestion={handleSuggestion}
                                                                            url="customers"
                                                                            filteredSuggestions={filteredSuggestions}
                                                                            setFilteredSuggestions={setFilteredSuggestions}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div className="col-md-12">
                                                                        <label>Customer </label>
                                                                        <h4>{customer}</h4>
                                                                    </div>
                                                            }

                                                            <div className="col-md-12">
                                                                <Input
                                                                    name="debit"
                                                                    id="debit"
                                                                    placeholder="Debit"
                                                                    errors={errors.debit}
                                                                    value={values.debit}
                                                                    handleChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <Input
                                                                    name="credit"
                                                                    id="credit"
                                                                    placeholder="Credit"
                                                                    errors={errors.credit}
                                                                    value={values.credit}
                                                                    handleChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <TextArea
                                                                    name="comment"
                                                                    id="comment"
                                                                    placeholder="Comment"
                                                                    errors={errors.comment}
                                                                    value={values.comment}
                                                                    handleChange={handleChange}
                                                                />
                                                            </div>

                                                        </div>

                                                        <div className="row ">
                                                            <div className="col-sm-12">
                                                                {
                                                                    !btnLoad ?
                                                                        <Button
                                                                            variant=""
                                                                            type="submit"
                                                                            className="btn btn-primary w-100"
                                                                        >
                                                                            Save changes
                                                                        </Button>
                                                                        :
                                                                        <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row ">
                                                            <div className="col-sm-12 mt-1">
                                                                {
                                                                    ledgerId > 0 ?
                                                                    <Button
                                                                        variant=""
                                                                        type="button"
                                                                        className="btn btn-warning w-100"
                                                                        onClick={CancelEdit}
                                                                    >
                                                                        Cancel Update
                                                                    </Button>
                                                                        :""
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="row ">
                                                            <div className="col-sm-12 mt-5">
                                                                {
                                                                    !btnClose ?
                                                                        <Button
                                                                            variant=""
                                                                            type="button"
                                                                            className="btn btn-danger w-100"
                                                                            onClick={() =>
                                                                                swal({
                                                                                    title: "Are you sure?",
                                                                                    text: "You will going to close the day transactions",
                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        DayClosing(filterDate.toISOString().split('T')[0])
                                                                                    } else {
                                                                                        swal("Day transaction not closed",{
                                                                                            icon:"error"
                                                                                        });
                                                                                    }
                                                                                })
                                                                            }
                                                                        >
                                                                            End Of Day
                                                                        </Button>
                                                                        :
                                                                        <h1 className="la la-circle-o-notch la-spin me-2 text-danger " style={{fontSize:'40px'}} ></h1>
                                                                }
                                                            </div>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>

                                        </Col>
                                        :
                                        <Col sm={12} md={3} lg={3}></Col>
                                }


                                <Col sm={12} md={9} lg={9}>
                                    {
                                        ledgerData.status ?
                                            <Table responsive className="header-border">
                                                <thead>
                                                <tr>
                                                    <th>Ledger Date</th>
                                                    <th>Customer</th>
                                                    <th>Debit</th>
                                                    <th>Credit</th>
                                                    <th>Balance</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    peginateData.length > 0 ?
                                                        peginateData.map((row,i) => (
                                                            <Fragment  key={i}>
                                                                <tr>
                                                                    <td style={{borderStyle:'dashed'}}>{row.ledger_date}</td>
                                                                    <td style={{borderStyle:'dashed'}}>{row.customer_name}</td>
                                                                    <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'D' ? row.transaction_amount : 0}</td>
                                                                    <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'C' ? row.transaction_amount : 0}</td>
                                                                    <td style={{borderStyle:'dashed'}}>{row.balance}</td>
                                                                    <td style={{borderStyle:'dashed'}}>
                                                                        <i onClick={() => ledgerDataEdit(row)} className="fa fa-edit cursor-pointer" style={{marginRight:'5px'}} ></i>
                                                                        {
                                                                            editable ?
                                                                                <SweetAlertButton
                                                                                    isSuccess={isSuccess}
                                                                                    actionFunc={()=>HandleDelete(row.id)}
                                                                                    icon='fa fa-minus-square cursor-pointer'
                                                                                    bodyMsg='Delete'
                                                                                    cancelMsg="Fail, Your data is secure"
                                                                                    okMsg={message}
                                                                                />
                                                                                : ""
                                                                        }

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="6"> Comment : {row.comment}</td>
                                                                </tr>
                                                            </Fragment>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                }
                                                </tbody>
                                            </Table>
                                            : ""
                                    }

                                    {
                                        ledgerData.status && ledgerData.data.length > 0 ?
                                            <div className="pt-2 m-l5">
                                                <PagePagination dataCount={ledgerData.data.length} perPage="1000" pegiFunction={peginate} />
                                            </div> : ""
                                    }
                                </Col>

                            </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );

}

const initMapStateToProps = state => ({
    login: state.auth,
    roles: state.roles,
    operation: state.operation,
    mount: state.mount,
    orgSession: state.orgSession

})

const initMapDispatchToProps = dispatch => ({
    roleFunc: () => dispatch(getRoleAsync()),
})

export default connect(initMapStateToProps,initMapDispatchToProps) (LedgerManage)